import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense, useEffect, useState } from "react";

const StudioEmbed = lazy(() => import("@/components/StudioEmbed"));

export const Route = createFileRoute("/admin/$")({
  head: () => ({
    meta: [
      { title: "Studio — AMR 3" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminSplatPage,
});

function AdminSplatPage() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <div className="fixed inset-0 z-[100] bg-background">
      {mounted ? (
        <Suspense
          fallback={
            <div className="flex h-full w-full items-center justify-center text-sm text-muted-foreground">
              Loading Studio…
            </div>
          }
        >
          <StudioEmbed />
        </Suspense>
      ) : null}
    </div>
  );
}
